webpackJsonp([81110738464436],{

/***/ 357:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/blog/2017-01-05-using-git-for-docs.md absPath of file >>> MarkdownRemark","html":"<h2>Git</h2>\n<p>Git is a version control system</p>\n<h2>Docs</h2>\n<p>Documentation is an essential aspect of any development enterprise.</p>","frontmatter":{"date":"January 05, 2017","title":"Using Git for Docs","description":"We can now use git to manage docs!","tags":["git","docs"]}}},"pathContext":{"id":"/opt/build/repo/src/pages/blog/2017-01-05-using-git-for-docs.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-2017-01-05-using-git-for-docs-bcbd4a8f61cb5598f3c8.js